import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiDeleteCity, apiGetCityTrashData, apiRecoverCity } from 'services/CityService'

export const getTrashCities = createAsyncThunk('cityTrash/data/getTrashCities',async (data) => {
    const response = await apiGetCityTrashData(data)
    return response.data
})

export const recoverCity = async (data) => {
    const response = await apiRecoverCity(data)
    return response.data
}

export const deleteCity = async (data) => {
    const response = await apiDeleteCity(data)
    return response.data
}

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    sort: {
        order: '',
        key: ''
    }
}

export const initialState = {
    loading: false,
    cityTrash: [],
    openFeedback: '',
    tableData: initialTableData,
}

const dataSlice = createSlice({
    name: 'cityTrash/data',
    initialState,
    reducers: {
        reset: () => initialState,
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
    },
    extraReducers: (builder) => {
		builder.addCase(getTrashCities.fulfilled, (state, action) => {
            state.cityTrash = action.payload.items
            state.tableData.total = action.payload?.meta?.totalItems
            state.openFeedback = action.payload?.open_feedback
            state.loading = false
        })
        builder.addCase(getTrashCities.pending, (state) => {
            state.loading = true
        })
    }
})

export const { reset, setTableData, setSortedColumns } = dataSlice.actions

export default dataSlice.reducer
